import React from 'react';
import { Box } from '@sparrowengg/twigs-react';
import Navbar from 'commons/components/navbar';
import AddWebhook from 'features/webhook/add-webhook';

const AddWebhookPage = () => {
  return (
    <Box
      css={{
        position: 'fixed',
        width: '100%'
      }}
    >
      <Navbar />
      <Box css={{ height: 'calc( 100vh - 72px )' }}>
        <AddWebhook />
      </Box>
    </Box>
  );
};

export default AddWebhookPage;
